import { SlidersHorizontal } from 'lucide-react';
import { tr } from '../lib/i18n.ts';
import { openSettings, useSettings } from '../settings/store.ts';
import { enabledWidgets } from './registry.ts';
import { useInfoBarPrefs } from './prefsStore.ts';

function WidgetList() {
  const prefs = useInfoBarPrefs();
  return enabledWidgets(prefs.widgets, 'main').map(({ id, Bar }) => <Bar key={id} variant="bar" />);
}

/** The widgets that fill the left of the top bar. Hiding them leaves an empty spacer, never a missing bar. */
export function InfoWidgets() {
  const visible = useInfoBarPrefs().visible;
  if (!visible) return <div className="infobar-main" />;
  return (
    <section className="infobar-main" aria-label={tr.infobar.label}>
      <WidgetList />
    </section>
  );
}

/** Invisible copy of every widget at its natural width, so the bar can decide what fits before drawing. */
export function WidgetMeasurer({ measurerRef }: { measurerRef: React.RefObject<HTMLDivElement | null> }) {
  const visible = useInfoBarPrefs().visible;
  return (
    <div ref={measurerRef} className="bar-measurer" aria-hidden inert>
      {visible && <WidgetList />}
    </div>
  );
}

/** Bell and the Ayarlar button; both stay whatever else the bar drops. */
export function InfoBarControls() {
  const prefs = useInfoBarPrefs();
  const settingsOpen = useSettings((state) => state.open);
  return (
    <>
      {enabledWidgets(prefs.widgets, 'end').map(({ id, Bar }) => (
        <Bar key={id} variant="bar" />
      ))}
      <button
        type="button"
        className="infobar-button"
        aria-haspopup="dialog"
        aria-expanded={settingsOpen}
        aria-label={tr.settings.open}
        title={`${tr.settings.open} (${tr.settings.hint})`}
        onClick={() => openSettings()}
      >
        <SlidersHorizontal size={17} aria-hidden />
      </button>
    </>
  );
}
